import styles from "./EmptyLabel.module.scss"
export default function EmptyLabel(props: {label: string}) {
    return <div className={styles.Container}>
        <div className={styles.EmptyLabel}>&pi;</div>
    </div>
}